export enum ShipmentOrdersRouteStatus {
  Optimized = 'OPTIMIZED',
  OptimizedAndRouteChanged = 'OPTIMIZED_AND_ROUTE_CHANGED',
  NotOptimized = 'NOT_OPTIMIZED',
  RouteChanged = 'ROUTE_CHANGED',
}
